import { Controller } from 'stimulus';

class GuideController extends Controller {
  onListItemClick(event) {
    const { currentTarget } = event;

    const controls = document.getElementById(currentTarget.getAttribute('aria-controls'));

    if (!controls) {
      throw new Error('Element to control is not found');
    }

    this.hideActiveItems();
    this.disableActiveListItems();

    controls.setAttribute('aria-hidden', 'false');
    currentTarget.setAttribute('aria-expanded', 'true');
  }

  hideActiveItems() {
    const activeItems = this.itemTargets.filter((item) => item.getAttribute('aria-hidden') === 'false');

    if (activeItems.length) {
      activeItems[0].setAttribute('aria-hidden', 'true');
    }
  }

  disableActiveListItems() {
    const activeItems = this.listItemTargets.filter((item) => item.getAttribute('aria-expanded') === 'true');

    if (activeItems.length) {
      activeItems[0].setAttribute('aria-expanded', 'false');
    }
  }
}

GuideController.targets = [
  'item',
  'listItem',
];

export default GuideController;
